import { InjectionToken } from '@angular/core';

export const DCSG_APP_NAME = new InjectionToken<any>('DCSG_APP_NAME');
